import { Flex, Typography } from 'antd';
import useNotifyError from 'hooks/useNotifyError';
import { useTranslation } from 'react-i18next';
import { SeasonParticipant } from 'types/common';
import FarmerApdCard from './FarmerApdCard';

interface FarmerApdListProps {
  farmers: SeasonParticipant[] | undefined;
  error: Error | null;
  isLoading: boolean;
  taskAssignmentId: string;
}

const FarmerApdList = ({
  taskAssignmentId,
  farmers,
  error,
  isLoading,
}: FarmerApdListProps) => {
  const { t } = useTranslation();

  useNotifyError({
    error,
    msg: 'Failed to load farmer APD list',
  });

  if (isLoading) {
    return (
      <Flex vertical gap={16}>
        {Array.from({ length: 3 }).map((_, index) => (
          <FarmerApdCard.Skeleton key={index} />
        ))}
      </Flex>
    );
  }

  if (!farmers?.length) {
    return (
      <Typography.Text strong className="text-center">
        {t('dashboard.noApdRecorded')}
      </Typography.Text>
    );
  }

  return (
    <Flex vertical gap={16}>
      {farmers?.map((participant) => (
        <FarmerApdCard
          key={participant.id}
          participant={participant}
          taskAssignmentId={taskAssignmentId}
        />
      ))}
    </Flex>
  );
};

export default FarmerApdList;
